// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yJNs","name":"styles_name__a_CM-","phone":"styles_phone__3qdjm"};